import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import { KeyboardArrowDown } from '@mui/icons-material';
import { Collapse, Typography } from '@mui/material';

import CopyButton from 'main/components/buttons/CopyButton';
import DownloadButton from 'main/components/buttons/DownloadButton';
import Hljs from 'main/components/Hljs';

const useStyles = makeStyles()((theme, _params, classes) => ({
    sourceData: {
        background: '#38383A',
        position: 'relative',
        padding: 20,
        borderRadius: 18,
        marginTop: 52,
        '& pre': {
            margin: '0'
        },
        [`&:hover .${classes.actionButtons}`]: {
            display: 'flex'
        }
    },
    actionButtons: {
        background: '#58585a',
        padding: 8,
        borderRadius: 8,
        position: 'absolute',
        right: 20,
        display: 'none'
    },
    actionButtonsSeparator: {
        borderRight: '1px solid #38383A',
        marginRight: 8,
        paddingLeft: 8
    },
    more: {
        marginTop: 10,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&>p, >svg': {
            fontWeight: 600,
            color: theme.palette.primary.main
        }
    },
    icon: {
        transition: 'all 0.3s ease-out'
    },
    mask: {
        maskImage: 'linear-gradient(to top, transparent 0%, black 18%)'
    }
}));

const ref = React.createRef();

const Code = ({ sourceData }) => {
    const { classes } = useStyles();
    const [open, setOpen] = useState(false);
    const [collapseSize, setCollapseSize] = useState(0);

    useEffect(() => {
        // Till the end of current view
        // ref.current.clientHeight > (window.innerHeight - ref.current.offsetTop) && setCollapseSize(window.innerHeight - ref.current.offsetTop - 80)
        // Till the end of page size
        if (ref.current) {
            ref.current.clientHeight > window.innerHeight && setCollapseSize(window.innerHeight);
        }
    }, []);

    const extractB64Code = (source) => {
        try {
            return atob(source);
        } catch (e) {
            console.warn("Can't extract Base64 source code", e);
            return source;
        }
    };

    if (!sourceData) {
        return null;
    }

    const code = sourceData.endsWith('=') ? extractB64Code(sourceData) : sourceData;

    const content = (
        <React.Fragment>
            <div className={classes.actionButtons}>
                <CopyButton iconButton value={code} />
                <div className={classes.actionButtonsSeparator} />
                <DownloadButton iconButton value={code} />
            </div>
            <Hljs language="bash">{code}</Hljs>
        </React.Fragment>
    );

    return (
        <div className={classes.sourceData} ref={ref}>
            {!collapseSize ? (
                content
            ) : (
                <React.Fragment>
                    <Collapse in={open} collapsedSize={collapseSize} classes={{ root: !open ? classes.mask : '' }}>
                        {content}
                    </Collapse>
                    <div className={classes.more} onClick={() => setOpen(!open)}>
                        <Typography variant="body2">{open ? 'Less' : 'More'}</Typography>
                        <KeyboardArrowDown
                            className={classes.icon}
                            style={{ transform: open ? 'rotate(-180deg)' : 'initial' }}
                        />
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

Code.propTypes = {
    sourceData: PropTypes.string
};

export default Code;
